import { useTheme } from "@emotion/react";
import { MDSPlanId } from "../plan-card.types";
import {
  StyledFeatureIcon,
  StyledFeatureRow,
  StyledPlanCardFeatures,
} from "./plan-card-features.styles";
import { MdsIconKind } from "@/design-system/components/icon";
import { MDSText, MDSTextVariant } from "@/mds/components/text";

interface MDSPlanCardFeaturesProps {
  plan: MDSPlanId;
  labels: string[];
}

export const MDSPlanCardFeatures = ({ plan, labels }: MDSPlanCardFeaturesProps) => {
  const theme = useTheme();

  return (
    <StyledPlanCardFeatures>
      {labels.map(label => (
        <StyledFeatureRow key={label}>
          <StyledFeatureIcon
            kind={MdsIconKind.Check}
            $color={
              plan === MDSPlanId.Paid ? theme.colors.icon.selected : theme.colors.icon.secondary
            }
          />
          <MDSText variant={MDSTextVariant.TextS}>{label}</MDSText>
        </StyledFeatureRow>
      ))}
    </StyledPlanCardFeatures>
  );
};
